import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAuthed, setIsAuthed] = useState(location.state?.user ? true : null);

  useEffect(() => {
    if (location.state?.user) return;
    const checkAuth = async () => {
      try {
        const res = await fetch(`${API}/auth/me`, { credentials: "include" });
        if (!res.ok) throw new Error("not authed");
        await res.json();
        setIsAuthed(true);
      } catch (e) {
        setIsAuthed(false);
        navigate("/login", { replace: true });
      }
    };
    checkAuth();
  }, [location.state, navigate]);

  if (isAuthed === null) {
    return (
      <div className="min-h-screen bg-brand-bg flex items-center justify-center">
        <div className="h-10 w-10 rounded-full border-2 border-brand-primary/20 border-t-brand-primary animate-spin" />
      </div>
    );
  }
  if (isAuthed === false) return null;
  return children;
}
